import * as Yup from 'yup'

const validationSchema = Yup.object({
  day: Yup.string()
    .oneOf([
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ])
    .required('Day is required'),
  isAlwaysOnline: Yup.boolean().default(false),
  slots: Yup.object().shape({
    morning: Yup.array()
      .of(Yup.string().required())
      .optional()
      .typeError('Morning must be an array of time slots'),
    afternoon: Yup.array()
      .of(Yup.string().required())
      .optional()
      .typeError('Afternoon must be an array of time slots'),
    evening: Yup.array()
      .of(Yup.string().required())
      .optional()
      .typeError('Evening must be an array of time slots'),
  }),
})
const timeRegex = /^([01]\d|2[0-3]):([0-5]\d)$/

const institutionValidationSchema = Yup.object({
  day: Yup.string()
    .oneOf([
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday',
    ])
    .required('Day is required'),
  isOpenAllDay: Yup.boolean().default(false),
  isClosed: Yup.boolean().default(false),
  startTime: Yup.string()
    .matches(timeRegex, 'Invalid time format for startTime')
    .nullable()
    .notRequired(),
  endTime: Yup.string()
    .matches(timeRegex, 'Invalid time format for endTime')
    .nullable()
    .notRequired(),
})
export default {
  validationSchema,
  institutionValidationSchema,
}
